import styled from 'styled-components';

export const Stack = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ $gap = 'md', theme }) => theme.space[$gap] || $gap};
`;

export const Row = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ $gap = 'sm', theme }) => theme.space[$gap] || $gap};
  flex-wrap: ${({ $wrap = false }) => ($wrap ? 'wrap' : 'nowrap')};
`;

export const Card = styled.section`
  background: ${({ theme }) => theme.colors.surface};
  border: 1px solid ${({ theme }) => theme.colors.border};
  border-radius: ${({ theme }) => theme.radius.md};
  box-shadow: ${({ theme }) => theme.shadow.subtle};
  padding: ${({ theme }) => theme.space.lg};
`;

export const PageHeader = styled.header`
  margin-bottom: ${({ theme }) => theme.space.lg};
`;

export const Eyebrow = styled.p`
  color: ${({ theme }) => theme.colors.accent};
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.09em;
  margin: 0 0 ${({ theme }) => theme.space.sm};
  text-transform: uppercase;
`;

export const PageTitle = styled.h1`
  font-family: ${({ theme }) => theme.typography.display};
  font-size: clamp(26px, 4vw, 38px);
  font-weight: 500;
  letter-spacing: -0.025em;
  margin: 0;
`;

export const MutedText = styled.p`
  color: ${({ theme }) => theme.colors.textMuted};
  margin: ${({ theme }) => theme.space.sm} 0 0;
`;

export const Button = styled.button`
  align-items: center;
  background: ${({ $variant, theme }) =>
    $variant === 'secondary' ? theme.colors.surface : theme.colors.text};
  border: 1px solid ${({ $variant, theme }) =>
    $variant === 'secondary' ? theme.colors.borderStrong : theme.colors.text};
  border-radius: ${({ theme }) => theme.radius.sm};
  color: ${({ $variant, theme }) =>
    $variant === 'secondary' ? theme.colors.text : theme.colors.surface};
  cursor: pointer;
  display: inline-flex;
  gap: ${({ theme }) => theme.space.sm};
  justify-content: center;
  min-height: 36px;
  padding: 7px 12px;
  &:hover { opacity: 0.82; }
`;
